/**
 * Simple Guide Selection Component for use in primereact data tables.
 */

import { type ColumnEditorOptions } from 'primereact/column';

import { DropdownEditor } from '../../common/components/GridCellEditors';
import { type GuideDetails } from '../../entities/entityTypes';

interface GuideSelectionDropdownProps {
    options: ColumnEditorOptions;
    guides: GuideDetails[];
}

export const GuideSelectionDropdown = ({
    options,
    guides,
}: GuideSelectionDropdownProps) => {
    return (
        <DropdownEditor
            options={options}
            dropdownProps={{
                options: guides.sort((a, b) =>
                    a.fullName.localeCompare(b.fullName),
                ),
                optionLabel: 'fullName',
                optionValue: 'id',
                placeholder: 'Select a Guide',
            }}
        />
    );
};
